import { t } from '../../../../utils/i18n';
import { ShippingError, type ShippingErrorValues } from '../../../../types/Shipping';
import { type GooglePayButtonConfig } from '../types';

type GetShippingContactErrorReturn = Awaited<ReturnType<GooglePayButtonConfig['onPaymentDataChanged']>>['error'];

export const getShippingContactError = (
  error: ShippingErrorValues = ShippingError.SHIPPING_UNKNOWN,
): GetShippingContactErrorReturn => {
  switch (error) {
    case ShippingError.SHIPPING_CONTACT_INVALID:
      return {
        intent: 'SHIPPING_ADDRESS',
        reason: 'SHIPPING_ADDRESS_INVALID',
        message: t('pm.shipping.contactInvalid'),
      };

    case ShippingError.SHIPPING_ADDRESS_UNSERVICEABLE:
      return {
        intent: 'SHIPPING_ADDRESS',
        reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
        message: t('pm.shipping.contactAddressUnserviceable'),
      };

    case ShippingError.SHIPPING_UNKNOWN:
    default:
      return { intent: 'SHIPPING_ADDRESS', reason: 'OTHER_ERROR', message: t('pm.shipping.unknownError') };
  }
};
